import { itemHasContent } from '../../utils/helpers';

const COST_FIELDS = ['name', 'amount', 'period'];
const PRODUCT_FIELDS = ['name', 'costPrice', 'unit'];
const REVENUE_FIELDS = ['name', 'description'];
const PRODUCT_SALES_FIELDS = ['name', 'endUserPrice', 'unit'];

export default function calculateCostRevenueProgress(
  rootState,
  minRequired = 1,
) {
  let filledCount = 0;
  let totalCollectionItems = 0;

  if (rootState.cost.collection.length) {
    rootState.cost.collection.forEach((item) => {
      let foundUnfilledField = false;
      COST_FIELDS.forEach((field) => {
        if (field === COST_FIELDS[1]) {
          // all items in the array should be at least 0 or bigger
          if (
            item[field] == null ||
            !Array.isArray(item[field]) ||
            item[field].length === 0 ||
            item[field].some((e) => e < 0)
          ) {
            foundUnfilledField = true;
          }
        } else if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });

      if (!foundUnfilledField) filledCount += 1;
    });
  }
  totalCollectionItems += rootState.cost.collection.length;

  if (rootState.product.collection.length) {
    rootState.product.collection.forEach((item) => {
      let foundUnfilledField = false;
      PRODUCT_FIELDS.forEach((field) => {
        if (field === PRODUCT_FIELDS[1]) {
          // transform to a number from a string and check if it's at least 0
          // when cost per unit gets cancelled it gets reset to an empty string
          if (
            item[field] == null ||
            item[field] === '' ||
            Number(item[field]) < 0
          ) {
            foundUnfilledField = true;
          }
        } else if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
    totalCollectionItems += rootState.product.collection.length;
  }

  if (rootState.revenue.collection.length) {
    rootState.revenue.collection.forEach((item) => {
      let foundUnfilledField = false;
      REVENUE_FIELDS.forEach((field) => {
        if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
    totalCollectionItems += rootState.revenue.collection.length;
  }

  if (rootState.product.collection.length) {
    rootState.product.collection.forEach((item) => {
      let foundUnfilledField = false;
      PRODUCT_SALES_FIELDS.forEach((field) => {
        if (field === PRODUCT_SALES_FIELDS[1]) {
          // transform to a number from a string and check if it's at least 0
          // when cost per unit gets cancelled it gets reset to an empty string
          if (
            item[field] == null ||
            item[field] === '' ||
            Number(item[field]) < 0
          ) {
            foundUnfilledField = true;
          }
        } else if (!itemHasContent(item, [field])) {
          foundUnfilledField = true;
        }
      });
      if (!foundUnfilledField) filledCount += 1;
    });
    totalCollectionItems += rootState.product.collection.length;

    rootState.product.collection.forEach((item) => {
      // item.sales has an array of null, empty strings or string with numbers; they should all be at least 0 or bigger
      let foundUnfilledField = false;
      if (
        !item.sales ||
        !Array.isArray(item.sales) ||
        item.sales.some((e) => {
          if (e == null || e === '' || Number(e) < 0) {
            return true;
          }
          return false;
        })
      ) {
        foundUnfilledField = true;
        return;
      }
      if (!foundUnfilledField) filledCount += 1;
    });
    totalCollectionItems += rootState.product.collection.length;
  }

  if (filledCount === 0) return 0;
  const denominator = Math.max(minRequired, totalCollectionItems);
  const sectionProgress = Math.round((filledCount / denominator) * 100);
  return sectionProgress;
}
